import { Option, OptionObj } from "../../models/select";

export const colorOptions = (): Option[] => {
  return [
    {
      name: "Brown",
      selected: false,
      color: "#3e2723"
    },
    {
      name: "Black",
      selected: false,
      color: "#212121"
    },
    {
      name: "Red",
      selected: false,
      color: "#ff5252"
    },
    {
      name: "Pink",
      selected: false,
      color: "#ff4081"
    },
    {
      name: "Violet",
      selected: false,
      color: "#e040fb"
    },
    {
      name: "Purple",
      selected: false,
      color: "#7c4dff"
    },
    {
      name: "Indigo",
      selected: false,
      color: "#536dfe"
    },
    {
      name: "Blue",
      selected: false,
      color: "#40c4ff"
    },
    {
      name: "Green",
      selected: false,
      color: "#69f0ae"
    },
    {
      name: "Yellow",
      selected: false,
      color: "#ffff41"
    },
    {
      name: "Amber",
      selected: false,
      color: "#ffd740"
    },
    {
      name: "Orange",
      selected: false,
      color: "#ffab40"
    }
  ];
};
export const lensOptions = (): Option[] => {
  return [
    {
      name: "Aviator",
      selected: false,
      svg: "./assets/images/aviator.JPG"
    },
    {
      name: "Square",
      selected: false,
      svg: "./assets/images/square.JPG"
    },
    {
      name: "Rectangle",
      selected: false,
      svg: "./assets/images/rectangle.JPG"
    },
    {
      name: "Butterfly",
      selected: false,
      svg: "./assets/images/butterfly.JPG"
    },
    {
      name: "Round",
      selected: false,
      svg: "./assets/images/round.JPG"
    },
    {
      name: "Oval",
      selected: false,
      svg: "./assets/images/oval.JPG"
    }
  ];
};
export const brandOptions = (): Option[] => [
  {
    name: "Polaroid",
    selected: false
  },
  {
    name: "Ray-Ban",
    selected: false
  },
  {
    name: "Furla",
    selected: false
  },
  {
    name: "Lozza",
    selected: false
  },
  {
    name: "Carrera",
    selected: false
  },
  {
    name: "Marc Jacobs",
    selected: false
  },
  {
    name: "Sunderson",
    selected: false
  },
  {
    name: "Calvin Klein",
    selected: false
  },
  {
    name: "Diesel",
    selected: false
  },
  {
    name: "Guess",
    selected: false
  },
  {
    name: "Coach",
    selected: false
  },
  {
    name: "Michael Kors",
    selected: false
  }
];

export default {
  colorOptions,
  brandOptions,
  lensOptions
};
